import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'lingui-react';
import FontAwesome from 'react-fontawesome';
import { QuickActionButton } from 'base-components';
import { compact } from 'lodash';
import { Column, Row } from 'styled-components-reactive-grid';

import ProgressBar from 'components/ProgressBar';
import TextDiv from 'elements/TextDiv';

import StatusPane from './StatusPane';
import ProgressPane from './ProgressPane';
import messages from './messages';

const WizardControllerHeader = ({
  configKey,
  handleWizardCancel,
  nextStep,
  nextStepDisabled,
  previousStep,
  previousStepDisabled,
  stepCount,
  stepIndex,
}) => (
  <StatusPane>
    <Row modifiers={['height_100', 'middle']}>
      <Column modifiers={['col_3', 'padScale_5']}>
        <TextDiv modifiers={['heavyText', 'mediumText', 'midGreyText', 'uppercase']}>
          <Trans id={messages[configKey]} />
        </TextDiv>
      </Column>
      <Column modifiers={['col_6']}>
        <Row modifiers={['middle']}>
          <Column modifiers={['col']} >
            <ProgressPane>
              {
                stepIndex < stepCount ?
                  <Trans
                    id={messages.wizardProgress}
                    values={{ step: stepIndex, total: stepCount - 1 }}
                  />
                  :
                  <Trans id={messages.wizardReview} />
              }
            </ProgressPane>
          </Column>
          <Column>
            <QuickActionButton
              modifiers={compact([
                'iconOnly',
                previousStepDisabled && 'disabled',
              ])}
              onClick={previousStep}
            >
              <FontAwesome name={'chevron-up'} />
            </QuickActionButton>
          </Column>
          <Column>
            <QuickActionButton
              modifiers={compact([
                'iconOnly',
                nextStepDisabled && 'disabled',
              ])}
              onClick={nextStep}
            >
              <FontAwesome name={'chevron-down'} />
            </QuickActionButton>
          </Column>
        </Row>
      </Column>
      <Column
        modifiers={['col_3', 'end', 'padScale_5']}
        style={{ display: 'flex' }}
      >
        <QuickActionButton
          modifiers={['iconOnly']}
          onClick={handleWizardCancel}
        >
          <FontAwesome name={'close'} />
        </QuickActionButton>
      </Column>
    </Row>
    <Row>
      <Column modifiers={['col_6', 'col_offset_3', 'padScale_0']}>
        <ProgressBar step={stepIndex} total={stepCount} />
      </Column>
    </Row>
  </StatusPane>
);

WizardControllerHeader.propTypes = {
  configKey: PropTypes.string.isRequired,
  handleWizardCancel: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  nextStepDisabled: PropTypes.bool,
  previousStep: PropTypes.func.isRequired,
  previousStepDisabled: PropTypes.bool,
  stepCount: PropTypes.number.isRequired,
  stepIndex: PropTypes.number.isRequired,
};

WizardControllerHeader.defaultProps = {
  nextStepDisabled: false,
  previousStepDisabled: false,
};

export default WizardControllerHeader;



// WEBPACK FOOTER //
// ./components/WizardControllerHeader/index.js